// src/api/apiPackages.js
import axios from "../utils/axios";

// Get Packages (with pagination & filters)
export const getAllPackages = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("packages", { params });
    return data;
};

// Get Packages for Select Dropdown
export const getPackagesForSelect = async () => {
    const { data } = await axios.get("packages/for-select");
    return data;
};

// Get Single Package
export const getPackage = async (id) => {
    if (!id) return null;
    const { data } = await axios.get(`packages/${id}`);
    return data;
};

// Create Package
export const createPackage = async (req) => {
    try {
        const { data } = await axios.post("packages", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createPackage error:", error);
        throw error;
    }
};

// Update Package
export const updatePackage = async (req, id) => {
    try {
        const { data } = await axios.put(`packages/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updatePackage error:", error);
        throw error;
    }
};

// Soft Delete Package
export const deletePackage = async (id) => {
    try {
        const { data } = await axios.delete(`packages/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deletePackage error:", error);
        throw error;
    }
};

// Mass Soft Delete Packages
export const deleteAllPackages = async (ids = []) => {
    try {
        const { data } = await axios.delete("packages/mass-destroy", {
            data: { items: ids },
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAllPackages error:", error);
        throw error;
    }
};

// Force Delete Package
export const forceDeletePackage = async (id) => {
    try {
        const { data } = await axios.delete(`packages/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeletePackage error:", error);
        throw error;
    }
};

// Mass Force Delete Packages
export const forceDeleteAllPackages = async (ids = []) => {
    try {
        const { data } = await axios.delete("packages/mass-force-delete", {
            data: { items: ids },
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAllPackages error:", error);
        throw error;
    }
};

// Restore Package
export const restorePackage = async (id) => {
    try {
        const { data } = await axios.post(`packages/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restorePackage error:", error);
        throw error;
    }
};

// Mass Restore Packages
export const restoreAllPackages = async (ids = []) => {
    try {
        const { data } = await axios.post("packages/mass-restore", { items: ids }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllPackages error:", error);
        throw error;
    }
};
